<div class="contentPosition" xmlns:sticky="http://www.w3.org/1999/xhtml">


  <!-- ENDE Suche nach projekt Name und Datum einzeln oder gemeinsam -->

<table mat-table [dataSource]="dataSource" matSort>
  <ng-container matColumnDef="projektName">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.timeDialog.projektName' | translate }} </th>
    <td mat-cell *matCellDef="let Zeit"> {{ Zeit.projektName }} </td>
    <td mat-footer-cell *matFooterCellDef>  </td>
  </ng-container>

  <ng-container matColumnDef="projekt">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.timeDialog.projekt' | translate }} </th>
    <td mat-cell *matCellDef="let Zeit"> {{ Zeit.projektstufe0 }} </td>
    <td mat-footer-cell *matFooterCellDef>  </td>
  </ng-container>

  <ng-container matColumnDef="datum">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.timeDialog.datum' | translate }} </th>
    <td mat-cell class="dateRow" *matCellDef="let Zeit"> {{ Zeit.datum | date: 'd.M.yyyy' }} </td>
    <td mat-footer-cell class="dateRow" *matFooterCellDef> {{'pages.timeDialog.total' | translate}} </td>
  </ng-container>

  <ng-container matColumnDef="dauerIntern">
    <th mat-header-cell *matHeaderCellDef class="dauerRechtsBuendig"> {{ 'pages.timeDialog.dauer.intern' | translate }} </th>
    <td mat-cell *matCellDef="let Zeit" class="dauerRechtsBuendigInhalt"> {{ Zeit.dauerIntern | number: '1.2-2':'de-CH'}} </td>
    <td mat-footer-cell class="dauerRechtsBuendigInhalt" *matFooterCellDef>{{dauerInternTotal | number: '1.2-2':'de-CH' }} </td>
  </ng-container>

  <ng-container matColumnDef="dauerExtern">
    <th mat-header-cell *matHeaderCellDef class="dauerRechtsBuendig"> {{ 'pages.timeDialog.dauer.extern' | translate }} </th>
    <td mat-cell *matCellDef="let Zeit" class="dauerRechtsBuendigInhalt"> {{ Zeit.dauerExtern | number:'1.2-2':'de-CH'}} </td>
    <td mat-footer-cell class="dauerRechtsBuendigInhalt" *matFooterCellDef>{{dauerExternTotal | number: '1.2-2':'de-CH'}} </td>
  </ng-container>

  <ng-container matColumnDef="spesen">
    <th mat-header-cell *matHeaderCellDef class="dauerRechtsBuendig"> {{ 'pages.timeDialog.spesen' | translate }} </th>
    <td mat-cell *matCellDef="let Zeit" class="dauerRechtsBuendigInhalt"> {{ Zeit.spesenTotal | number:'1.2-2':'de-CH'}} </td>
    <td mat-footer-cell  class="dauerRechtsBuendigInhalt" *matFooterCellDef>
      {{spesenTotalIntern | number: '1.2-2':'de-CH'}}
    </td>
  </ng-container>

  <ng-container matColumnDef="text">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.timeDialog.text' | translate }} </th>
    <td mat-cell *matCellDef="let Zeit"> {{ Zeit.text }} </td>
    <td mat-footer-cell class="saldoFooter" *matFooterCellDef>
      <!--   {{zeitSaldo | number: '1.2':'en-US'}} -->
       </td>
     </ng-container>

       <ng-container matColumnDef="verrechnen">
         <th mat-header-cell *matHeaderCellDef class="hCellCentral"> {{ 'pages.timeDialog.verrechnen' | translate }} </th>
         <td mat-cell *matCellDef="let Zeit" class="dauerRechtsBuendigInhalt"> {{ Zeit.verrechnen }} </td>
         <td mat-footer-cell class="saldoFooter" *matFooterCellDef>
    <!--       <ng-container *ngIf="ferienSaldo">{{ 'pages.timeDialog.saldoFerien' | translate }}</ng-container> -->
         </td>
       </ng-container>

       <ng-container matColumnDef="niverbar">
         <th mat-header-cell *matHeaderCellDef class="hCellCentral"> {{ 'pages.timeDialog.niverbar' | translate }} </th>
         <td mat-cell *matCellDef="let Zeit" class="dauerRechtsBuendigInhalt"> {{ Zeit.niverbar }} </td>
         <td mat-footer-cell class="saldoFooter" *matFooterCellDef>
     <!--      {{ferienSaldo | number: '1.2':'en-US'}}-->
         </td>
       </ng-container>

       <ng-container matColumnDef="verrechnet">
         <th mat-header-cell *matHeaderCellDef class="hCellCentral"> {{ 'pages.timeDialog.verrechnet' | translate }} </th>
         <td mat-cell *matCellDef="let Zeit" class="dauerRechtsBuendigInhalt"> {{ Zeit.verrechnet }} </td>
         <td mat-footer-cell class="saldoFooter" *matFooterCellDef>
           <!--    {{datumSaldo | date: 'dd.MM.yyyy' }} -->
         </td>
       </ng-container>

     <ng-container matColumnDef="actions">
       <th mat-header-cell *matHeaderCellDef> </th>
       <td mat-cell class="dauerRechtsBuendigInhalt" *matCellDef="let Zeit">
         <button class="action-menu-button" mat-icon-button [matMenuTriggerFor]="actionMenu" [disableRipple]="true">
           <mat-icon>more_vert</mat-icon>
         </button>
         <mat-menu #actionMenu="matMenu">
           <button [disabled]="!bNewShow" mat-menu-item (click)="edit.emit(Zeit)" class="keinRahmen" [disableRipple]="true" matTooltip="Bearbeiten des Eintrags" matTooltipShowDelay='2000'>{{ 'pages.timeDialog.functionMenu.edit' | translate }}</button>
           <button [disabled]="!bNewShow" mat-menu-item (click)="delete.emit(Zeit)" class="keinRahmen"
                   [disableRipple]="true" matTooltip="Löschen des Eintrags" matTooltipShowDelay='2000'>
             {{ 'pages.timeDialog.functionMenu.delete' | translate }}</button>
           <button *ngIf="!isSmallDevice" [disabled]="!bNewShow" mat-menu-item (click)="openAuswertungen.emit(Zeit.projekt)" class="keinRahmen" [disableRipple]="true" matTooltipShowDelay='2000'>{{ 'pages.timeDialog.functionMenu.print' | translate }}</button>
         </mat-menu>
       </td>
       <td mat-footer-cell *matFooterCellDef="let Zeit">
         <button *ngIf="ferienSaldo && zeitSaldo" class="action-menu-button" mat-icon-button [matMenuTriggerFor]="saldoReportMenu" [disableRipple]="true">

           <mat-icon>print</mat-icon>
         </button>
         <mat-menu #saldoReportMenu="matMenu">
           <button  (click)="saldoReport.emit(userId)" *ngIf="!isSmallDevice" [disabled]="!bNewShow" mat-menu-item
                   class="keinRahmen" [disableRipple]="true">{{ 'pages.timeDialog.functionMenu.saldoReport' | translate }}</button>
           <button mat-menu-item (click)="openFerienReport.emit()" >{{ 'pages.zeitverwaltung.ferienDrucken' | translate}}</button>
         </mat-menu>
       </td>
     </ng-container>
     <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
  <ng-container *ngIf="!bNewShow">
     <tr class="mRow" mat-row *matRowDef="let myRowData; columns: displayedColumns"></tr>
  </ng-container>
  <ng-container *ngIf="bNewShow">
    <tr class="mRow" mat-row *matRowDef="let myRowData; columns: displayedColumns" (dblclick)="edit.emit(myRowData)"></tr>
  </ng-container>
     <tr class="noBorders tableFooter" mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
   </table>
   </div>

